import _ from 'lodash'
import { NextPageContext } from 'next'
import { all, call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects'

import { validateField, validateFields } from 'common/validator'
import buildService from 'common/utils/build-service'
import { getJournalsService, patchJournalService, postJournalService } from 'services/journals'
import { modulesService } from 'services/modules'
import { changeModal } from 'services/actions'

import {
  addFieldError,
  addFieldsErrors,
  clearFieldError,
  LOAD_JOURNAL_DETAILS_PAGE_DATA,
  resetJournalFormData,
  SUBMIT_JOURNAL,
  VALIDATE_JOURNAL_FIELD,
} from './actions'
import { JournalSubmitPayload } from './types'

interface SubmitJournalAction {
  type: typeof SUBMIT_JOURNAL
  payload: JournalSubmitPayload
}

interface ValidateFieldAction {
  type: typeof VALIDATE_JOURNAL_FIELD
  payload: {
    field: string
    value: string
    validations: string
  }
}

interface LoadJournalPageDataAction {
  type: typeof LOAD_JOURNAL_DETAILS_PAGE_DATA
  payload: {
    urlParams?: { personId: string }
    req?: NextPageContext['req']
  }
}

export function* submitJournalSaga({ payload }: SubmitJournalAction) {
  const errors = validateFields(payload)

  if (_.isEmpty(errors)) {
    const data = {
      person_id: payload.currentUserId.value,
      name: payload.name.value,
      content: payload.content.value,
    }

    let response = null
    if (payload.id.value) {
      // @ts-expect-error no saga types
      response = yield call(patchJournalService.requestSaga, {
        payload: {
          data,
          urlParams: {
            id: payload.id.value,
          },
        },
      })
    } else {
      // @ts-expect-error no saga types
      response = yield call(postJournalService.requestSaga, {
        payload: { data },
      })
    }
    if (response.error) return
    // @ts-expect-error no saga types
    yield put(getJournalsService.actions.request({ urlParams: { personId: data.person_id } }))
    yield put(changeModal({ isOpen: false }))
    yield put(resetJournalFormData())
  } else {
    // @ts-expect-error no saga types
    yield put(addFieldsErrors(errors))
  }
}

export const deleteJournalService = buildService({
  type: 'DELETE',
  constantsPrefix: 'JOURNAL',
  http: {
    createApiUrlSuffix: ({ id }: { id: string }) => `/journals?id=eq.${id}`,
    *successHandler(journal: { id: string }) {
      // @ts-expect-error no saga types
      yield put(getJournalsService.actions.removeItem({ id: journal.id }))
      yield put(changeModal({ isOpen: false }))
    },
  },
})

export function* validateFieldSaga({
  payload: { field, value, validations },
}: ValidateFieldAction) {
  // @ts-expect-error no validate field types
  const error = validateField({ field, value, fieldValidations: validations })

  if (error) {
    yield put(addFieldError({ field, error }))
  } else {
    yield put(clearFieldError({ field }))
  }
}

export function* loadJournalPageDataSaga({ payload }: LoadJournalPageDataAction) {
  // @ts-expect-error no saga types
  yield call(getJournalsService.requestSaga, {
    payload,
  })
  // @ts-expect-error no saga types
  yield call(modulesService.requestSaga, {
    payload,
  })
}

export default function* saga() {
  yield all([
    takeEvery(VALIDATE_JOURNAL_FIELD, validateFieldSaga),
    takeLatest(SUBMIT_JOURNAL, submitJournalSaga),
    takeLatest(LOAD_JOURNAL_DETAILS_PAGE_DATA, loadJournalPageDataSaga),
    fork(deleteJournalService.saga),
  ])
}
